import React from 'react';
import { Icon } from 'antd';

const PrevArrow = ({ className, style, onClick }) => (
  <div
    className={className}
    style={{ ...style, display: 'block', left: -20 }}
    onClick={onClick}
    role="button"
  >
    <Icon type="left" style={{ color: '#AAA', fontSize: 20 }} />
  </div>
);

export default PrevArrow;




// WEBPACK FOOTER //
// ./src/screens/Home/components/PrevArrow.js